import { render, staticRenderFns } from "./adduser.vue?vue&type=template&id=22144636&scoped=true&"
import script from "./adduser.vue?vue&type=script&lang=js&"
export * from "./adduser.vue?vue&type=script&lang=js&"
import style0 from "./adduser.vue?vue&type=style&index=0&id=22144636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22144636",
  null
  
)

export default component.exports